<template>
  <div>

    <v-collapse :bordered="false" class="search-collapse" v-model="searchFilterIndex" @change="filtersStatusChange" >
      <v-panel header="Search / Filter" index="1">
        <div class="search-wrap">

          <div class="row">
            <div class="col">
              <label>Province:</label>
              <v-select placeholder="Province" size="medium" v-model="form.province"
                :data="optionsProvince" @change="(value) => selectProvince('province', value)"
                style="width:100%"></v-select>
            </div>
            <div class="col">
              <label>College:</label>
              <v-select placeholder="College" size="medium" v-model="form.college"
                :data="optionsCollege" @change="(value) => selectChange('college', value)"
                style="width:100%"></v-select>
            </div>
            <div class="col">
              <label>Intake:</label>
              <v-select placeholder="Intake" size="medium" v-model="form.intake"
                :data="optionsIntake" @change="(value) => selectIntake('intake', value)"
                style="width:100%"></v-select>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label>Level of Study:</label>
              <v-select placeholder="Level of study" size="medium" v-model="form.level_of_study"
                :data="optionsStudyLevels" @change="(value) => selectChange('level_of_study', value)"
                style="width:100%"></v-select>
            </div>
            <div class="col">
              <label>Area of Study:</label>
              <v-select placeholder="Area of study" size="medium" v-model="form.area_of_study"
                :data="optionsStudyAreas" @change="(value) => selectChange('area_of_study', value)"
                style="width:100%"></v-select>
            </div>
            <div class="col">
              <label>Test Score:</label>
              <v-select placeholder="Test Score" size="medium" v-model="form.ielts"
                :data="optionsTestscore" @change="(value) => selectChange('ielts', value)"
                style="width:100%"></v-select>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label>Keyword search:</label>
              <v-input placeholder="Keyword search" style="width: 100%" v-model="form.keyword" disabled></v-input>
            </div>
            <div class="col">
              <v-button type="default" size="medium" @click="(e) => closeFilters()">Clear Filters</v-button>
            </div>
            <div class="col">
              <v-button type="primary" size="medium" @click="ApplyFilters">Submit</v-button>
            </div>
          </div>

        </div>
      </v-panel>
    </v-collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ProgramsFilter',
  props: ['filterSchoolPrograms', 'setFilters'],
  data () {
    return {
      filters: [],
      searchFilterIndex: ['1'],
      filtersForm: {},
      form: {
        province: null,
        college: null,
        level_of_study: null,
        area_of_study: null,
        intake: null,
        ielts: null,
        keyword: null
      },
      optionsProvince: [],
      optionsCollege: [],
      collegesList: [],
      optionsStudyAreas: [],
      optionsTestscore: [],
      optionsStudyLevels: [{
        label: 'Grade-10',
        value: 'G10'
      }, {
        label: 'Grade-12',
        value: 'G12'
      }, {
        label: '1-Year Post-Secondary Certificate',
        value: 'D1'
      }, {
        label: '2-Year Undergraduate Diploma',
        value: 'D2'
      }, {
        label: '3-Year Undergraduate Advanced Diploma',
        value: 'D3'
      }, {
        label: '4-Year Bachelor\'s Degree',
        value: 'B4'
      }, {
        label: 'Postgraduate Certificate / Master\'s Degree',
        value: 'PG'
      }],
      optionsIntake: [{
        label: 'September',
        value: 'september'
      }, {
        label: 'January',
        value: 'january'
      }, {
        label: 'May',
        value: 'may'
      }]
    }
  },
  computed: {
    ...mapGetters([
      'lov'
    ])
  },
  methods: {
    closeFilters () {
      this.filtersForm = {}
      this.form = {
        province: null,
        college: null,
        level_of_study: null,
        area_of_study: null,
        intake: null,
        ielts: null,
        keyword: null
      }
      if (this.filters.length) {
        this.filters = []
        this.filterSchoolPrograms(this.filters)
        this.setFilters(this.filters)
      }
    },
    ApplyFilters (e) {
      this.filters = []
      for (let key in this.filtersForm) {
        if (this.filtersForm[key]) {
          const operator = (key === 'ielts') ? '>=' : '=='
          this.filters.push({
            key: key,
            value: this.filtersForm[key],
            operator: operator
          })
        }
      }
      this.filterSchoolPrograms(this.filters)
    },
    selectProvince (key, val) {
      this.selectChange(key, val)
      if (val) {
        const colleges = [...this.lov.provinces[val]]
        this.optionsCollege = colleges.map(college => {
          return {
            label: college,
            value: college
          }
        })
      } else {
        this.optionsCollege = [...this.collegesList]
      }
    },
    selectChange (key, val) {
      this.form[key] = val
      if (key === 'province') {
        key = `school.province`
      } else if (key === 'college') {
        key = `school.school_campus`
      }
      this.filtersForm[key] = val
    },
    selectIntake (key, val) {
      const intake = ['january', 'may', 'september']
      this.form[key] = val
      if (val) {
        intake.forEach((x) => { (val === x ? this.filtersForm[x] = 1 : this.filtersForm[x] = 0) })
      } else {
        intake.forEach(x => delete this.filtersForm[x])
      }
    },
    filtersShow () {
      this.showFilters = true
    },
    filtersStatusChange (index, status) {
      if (!status) {
        this.closeFilters()
      }
    }
  },
  watch: {
    lov: {
      handler (val) {
        if (!this.lov) {
          this.$store.dispatch('getLov')
        } else if (val) {
          for (let key in val.ielts) {
            this.optionsTestscore.push({
              label: val.ielts[key],
              value: val.ielts[key]
            })
          }
          for (let key in val.study_areas) {
            this.optionsStudyAreas.push({
              label: key,
              value: key
            })
          }
          for (let key in val.provinces) {
            this.optionsProvince.push({
              label: key,
              value: key
            })
            val.provinces[key].map(college => {
              this.optionsCollege.push({
                label: college,
                value: college
              })
            })
          }
          this.collegesList = [...this.optionsCollege]
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.filter-wrap {
  display: flex;
  justify-content: space-between;
  min-height: 40px;
}
.filter-wrap i {
  cursor: pointer;
  font-size: 17px;
}
.search-wrap {
  -webkit-box-shadow: 0px 0px 1px 1px rgba(168, 168, 168, 0.72);
  -moz-box-shadow: 0px 0px 1px 1px rgba(168,168,168,0.72);
  box-shadow: 0px 0px 1px 1px rgba(168,168,168,0.72);
  padding: 8px;
}
.search-wrap .row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.search-wrap .col {
  width: 31%;
  display: flex;
  justify-content: space-around;
}
.search-wrap .col label {
  font-weight: bold;
  margin-right: 12px;
  align-items: center;
  display: flex;
  width: 48%;
}
.search-wrap .col button {
  width: 100%;
}
</style>

<style>
/* .search-collapse .ant-collapse-header, .search-collapse .ant-collapse-header:hover {
  background-color: #108ee9 !important;
  color: #fff !important;
}
.search-collapse .ant-collapse-header i, .search-collapse .ant-collapse-header:hover i {
  color: #fff !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/ProgramsFilter.vue